import React from 'react';
import Me from './assets/me.png';

const works = [
  { title: 'Freelysta', href: 'https://freelysta.com', shot: '/projects/freelysta-header.png', tilt: '-rotate-2' },
  { title: 'GoForCab', href: 'https://goforcab.com', shot: '/projects/goforcab-header.png', tilt: 'rotate-2' },
  { title: 'AINOR', href: 'https://myainor.com', shot: '/projects/ainor-header.png', tilt: '-rotate-1' },
  { title: 'Livestayy', href: 'https://livestayy.com', shot: '/projects/livestayy-header.png', tilt: 'rotate-1' },
];

const ticker = ['Freelysta', 'GoForCab', 'AINOR', 'Livestayy', 'MCA · AI/ML', 'Full stack', 'Open for work'];

const Hero = () => {
  return (
    <section id="home">
      <div className="wrap grid grid-cols-1 lg:grid-cols-[1fr_1.15fr] gap-12 lg:gap-16 items-center py-12 md:py-16">
        <div>
          <div className="flex items-center gap-3 mb-7">
            <img src={Me} alt="Karan Dixit" className="w-14 h-14 rounded-full object-cover grayscale" />
            <div>
              <p className="t-kicker">Software Engineering Intern</p>
              <p className="text-sm text-[var(--muted)] mt-1">InTalksAI · MCA (AI/ML)</p>
            </div>
          </div>

          <h1 className="t-display whitespace-nowrap text-[clamp(40px,6.4vw,72px)] mb-6">
            Karan <em className="italic text-[var(--signal)]">Dixit</em>
          </h1>

          <p className="t-body max-w-md mb-8">
            I build live products people actually use — freelancer tools, cab booking, a web agency, and an OS for rental owners.
          </p>

          <div className="flex flex-wrap items-center gap-3">
            <button
              onClick={() => document.getElementById('projects')?.scrollIntoView({ behavior: 'smooth' })}
              className="btn-signal"
            >
              See the work
            </button>
            <a href="#contact" className="btn-ghost">Let’s talk</a>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 md:gap-4 items-start">
          {works.map((work) => (
            <a
              key={work.title}
              href={work.href}
              target="_blank"
              rel="noopener noreferrer"
              className={`stage-card ${work.tilt} no-underline`}
            >
              <img src={work.shot} alt={`${work.title} homepage`} />
              <span>{work.title}</span>
            </a>
          ))}
        </div>
      </div>

      <div className="ticker" aria-hidden="true">
        <div className="ticker-track">
          {[...ticker, ...ticker].map((item, i) => (
            <span key={`${item}-${i}`}>
              {item} <em>✦</em>
            </span>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Hero;
